import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=0b825b90&scoped=true&"
import script from "./AddRole.vue?vue&type=script&lang=js&"
export * from "./AddRole.vue?vue&type=script&lang=js&"
import style0 from "./AddRole.vue?vue&type=style&index=0&id=0b825b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b825b90",
  null
  
)

export default component.exports